// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import packageIcon from "@/assets/icons/package.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type PackageIconProps = Omit<IconProps, "name">;

export function PackageIcon(props: PackageIconProps): React.ReactNode {
  return <Icon name={packageIcon} {...props} />;
}
